type ComposerDirtyState = {
    attributes: unknown;
    templates: unknown;
    areas: unknown;
    designs: Map<unknown, unknown>;
    productQuantity: unknown;
    ecommerceSettings: unknown;
};

const dirtySnapshotReplacer = (key: string, value: unknown) => {
    // Validation decorates nodes with fresh Maps. Those warnings are derived UI state and must
    // not turn a freshly loaded Composer into an edited one.
    if (key === 'brokenValues') return undefined;

    if (value instanceof Map) {
        return Array.from(value.entries()).sort(([left], [right]) => String(left).localeCompare(String(right)));
    }

    if (value && typeof value === 'object' && 'toJSON' in value && typeof (value as { toJSON?: unknown }).toJSON === 'function') {
        return (value as { toJSON: () => unknown }).toJSON();
    }

    return value;
};

/**
 * Captures only persisted Composer data. Selection, validation and other view-only state are
 * deliberately excluded so background hydration cannot create a false unsaved-change warning.
 */
export const createComposerDirtySnapshot = (state: ComposerDirtyState) =>
    JSON.stringify(
        {
            attributes: state.attributes,
            templates: state.templates,
            areas: state.areas,
            designs: state.designs,
            productQuantity: state.productQuantity,
            ecommerceSettings: state.ecommerceSettings
        },
        dirtySnapshotReplacer
    );
